import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { of } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';

@Pipe({ name: 'urlBlob', pure: true })
export class UrlBlobPipe implements PipeTransform {
  constructor(private sharedService: SharedService, private _sanitizer: DomSanitizer) { }
  async transform(url: string, type: string = 'image/jpeg'): Promise<SafeResourceUrl> {
    try {
      var file = await this.sharedService.getFileFromUrl(url);
      let blob = new Blob([file], { type: type });
      return this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    } catch { return of(''); }
  }
}


